import Vue from 'vue'
import Router from 'vue-router'
import ListCustomer from '@/components/customer/ListCustomer'
import CustomerForm from '@/components/customer/CustomerForm'
import ShowTask from '@/components/task/ShowTask'
import ShowResale from '@/components/resale/ShowResale'
import ShowResaleReason from '@/components/resalereason/ShowResaleReason'
import AddTask from '@/components/task/AddTask'
import AddResale from '@/components/resale/AddResale'
import AddResaleReason from '@/components/resalereason/AddResaleReason'
import TaskView from '@/components/task/TaskView'
import WelcomeCustomers from '@/components/welcomeLetter/WelcomeCustomers'
import CreateBusinessUnit from '@/components/businessUnit/CreateBusinessUnit'
/* Custom Component start */
import FrontHome from '@/components/FrontHome'
import callCreate from '@/components/callsAndEmails/callCreate'
import CaseComponent from '@/components/cases/CaseComponent'
import StaffLogin from '@/components/StaffLogin'
import AddEmployee from '@/components/employee/AddEmployee'
import ListCall from '@/components/callsAndEmails/ListCall'
import CallsView from '@/components/callsAndEmails/CallsView'
import ListDunningNotice from '@/components/dunningNotices/ListDunningNotice'
import ListDunningNotices from '@/components/dunningNotices/ListDunningNotices'
import CaseList from '@/components/cases/CaseList'
import CaseCreate from '@/components/cases/CaseCreate'
import CustomerView from '@/components/customer/CustomerView'
import CaseView from '@/components/cases/CaseView'
import ListBusinessUnits from '@/components/businessUnit/ListBusinessUnits'

import ListEmployee from '@/components/employee/ListEmployee'
import ListCollector from '@/components/employee/ListCollector'
import viewEmployee from '@/components/employee/viewEmployee'
import viewContact from '@/components/contact/viewContact'
import viewProfile from '@/components/viewProfile'
/* Contaccts */
import ListContacts from '@/components/contact/ListContacts'
import ContactView from '@/components/contact/ContactView'

/* Email history list */
import ListEmails from '@/components/emailHistory/ListEmails'
import ListJobs from '@/components/jobs/ListJobs'
import ListRole from '@/components/rolePermission/ListRole'
import RoleCreate from '@/components/rolePermission/RoleCreate'
import ListPermissions from '@/components/rolePermission/ListPermissions'
import PermissionsCreate from '@/components/rolePermission/PermissionsCreate'
import ChangePassword from '@/components/ChangePassword'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import ContactRequestCreate from '@/components/contactRequest/ContactRequestCreate'
import ContactRequestList from '@/components/contactRequest/ContactRequestList'
import ContactRequestView from '@/components/contactRequest/ContactRequestView'

import CreateContact from '@/components/contact/CreateContact'

import EmailBounceList from '@/components/emailBounce/EmailBounceList'

/* Customer Summary */
import ListCustomerSummary from '@/components/customerSummary/ListCustomerSummary'
import ListCustomerSummaryDocs from '@/components/customerSummary/ListCustomerSummaryDocs'
import AddLien from '@/components/lien/AddLien'
import ShowLien from '@/components/lien/ShowLien'
import AddCard from '@/components/creditCard/AddCard'

import ShowFollowup from '@/components/followup/ShowFollowup'
import AddFollowup from '@/components/followup/AddFollowup'
import FollowupView from '@/components/followup/FollowupView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/customersummary/list',
      name: 'ListCustomerSummary',
      component: ListCustomerSummary
    },
    {
      path: '/customersummarydocs/list',
      name: 'ListCustomerSummaryDocs',
      component: ListCustomerSummaryDocs
    },
    {
      path: '/',
      name: 'FrontHome',
      component: FrontHome
    },
    {
      path: '/login',
      name: 'StaffLogin',
      component: StaffLogin
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/resetpassword/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/case',
      name: 'CaseComponent',
      component: CaseComponent

    },
    {
      path: '/listcustomer',
      name: 'ListCustomer',
      component: ListCustomer
    },
    {
      path: '/listcustomersummary',
      name: 'ListCustomerSummary',
      component: ListCustomerSummary
    },
    {
      path: '/listcustomersummarydocs',
      name: 'ListCustomerSummaryDocs',
      component: ListCustomerSummaryDocs
    },
    {
      path: '/list/welcomecustomers',
      name: 'WelcomeCustomers',
      component: WelcomeCustomers
    },
    {
      path: '/addemployee',
      name: 'AddEmployee',
      component: AddEmployee
    },
    {
      path: '/viewemployee/:id',
      name: 'viewEmployee',
      component: viewEmployee
    },
    {
      path: '/customerform/:id',
      name: 'CustomerForm',
      component: CustomerForm
    },
    {
      path: '/task/list',
      name: 'ShowTask',
      component: ShowTask
    },
    {
      path: '/resale/list',
      name: 'ShowResale',
      component: ShowResale
    },
    {
      path: '/resale/reason/list',
      name: 'ShowResaleReason',
      component: ShowResaleReason
    },
    {
      path: '/resale/reason/create/:id/:last',
      name: 'AddResaleReason',
      component: AddResaleReason
    },
    {
      path: '/resale/reason/update/:id/:last',
      name: 'EditResaleReason',
      component: AddResaleReason
    },

    {
      path: '/task/create/:id',
      name: 'AddTask',
      component: AddTask
    },
    {
      path: '/resale/create/:id',
      name: 'AddResale',
      component: AddResale
    },
    {
      path: '/resale/update/:id/:from',
      name: 'EditResale',
      component: AddResale
    },
    {
      path: '/task/update/:id/:from',
      name: 'EditTask',
      component: AddTask
    },
    {
      path: '/task/delete/:id',
      name: 'DeleteTask',
      component: ShowTask
    },
    {
      path: '/task/view/:id/:from',
      name: 'TaskView',
      component: TaskView
    },
    {
      path: '/calls/create/:id',
      name: 'callCreate',
      component: callCreate
    },
    {
      path: '/listcall',
      name: 'ListCall',
      component: ListCall
    },
    {
      path: '/calls/update/:id/:from',
      name: 'EditCall',
      component: callCreate
    },
    {
      path: '/calls/view/:id/:from',
      name: 'CallsView',
      component: CallsView
    },
    {
      path: '/case/list',
      name: 'CaseList',
      component: CaseList
    },
    {
      path: '/case/create/:id',
      name: 'CaseCreate',
      component: CaseCreate
    },
    {
      path: '/case/update/:id/:from',
      name: 'CaseUpdate',
      component: CaseCreate
    },
    {
      path: '/case/view/:id/:from',
      name: 'CaseView',
      component: CaseView
    },
    {
      path: '/contacts/create/:id',
      name: 'CreateContact',
      component: CreateContact
    },
    {
      path: '/listcontacts',
      name: 'ListContacts',
      component: ListContacts
    },
    {
      path: '/contact/view/:id/:from',
      name: 'ContactView',
      component: ContactView
    },
    {
      path: '/contacts/update/:id/:from',
      name: 'EditContact',
      component: CreateContact
    },
    {
      path: '/customer/dunning-notices',
      name: 'ListDunningNotice',
      component: ListDunningNotice
    },
    {
      path: '/customer/dunningnotices',
      name: 'ListDunningNotices',
      component: ListDunningNotices
    },
    {
      path: '/customer/view/:id',
      name: 'CustomerView',
      component: CustomerView
    },
    {
      path: '/listemployee',
      name: 'ListEmployee',
      component: ListEmployee
    },
    {
      path: '/listcollector',
      name: 'ListCollector',
      component: ListCollector
    },
    {
      path: '/viewcontact/:id',
      name: 'viewContact',
      component: viewContact
    },
    {
      path: '/listemails',
      name: 'ListEmails',
      component: ListEmails
    },
    {
      path: '/listjobs',
      name: 'ListJobs',
      component: ListJobs
    },
    {
      path: '/listrole',
      name: 'ListRole',
      component: ListRole
    },
    {
      path: '/role/create',
      name: 'RoleCreate',
      component: RoleCreate
    },
    {
      path: '/role/update/:id',
      name: 'EditRole',
      component: RoleCreate
    },
    {
      path: '/listpermissions',
      name: 'ListPermissions',
      component: ListPermissions
    },
    {
      path: '/permissions/create',
      name: 'PermissionsCreate',
      component: PermissionsCreate
    },
    {
      path: '/permissions/update/:id',
      name: 'EditPermissions',
      component: PermissionsCreate
    },
    {
      path: '/listbusinessunits',
      name: 'ListBusinessUnits',
      component: ListBusinessUnits
    },
    {
      path: '/createbusinessunit',
      name: 'CreateBusinessUnit',
      component: CreateBusinessUnit
    },
    {
      path: '/businessunit/update/:id',
      name: 'EditBusinessUnit',
      component: CreateBusinessUnit
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/contact_request/create',
      name: 'ContactRequestCreate',
      component: ContactRequestCreate
    },
    {
      path: '/contact_request/update/:id',
      name: 'EditContactRequest',
      component: ContactRequestCreate
    },
    {
      path: '/contact_request/list',
      name: 'ContactRequestList',
      component: ContactRequestList
    },
    {
      path: '/contact_request/view/:id',
      name: 'ContactRequestView',
      component: ContactRequestView
    },
    {
      path: '/viewprofile',
      name: 'viewProfile',
      component: viewProfile
    },
    /* {
                 path: '/',
                 name: 'HelloWorld',
                 component: HelloWorld
                 } */

    {
      path: '/email_bounce/list',
      name: 'EmailBounceList',
      component: EmailBounceList
    },

    {
      path: '/lien/create/:id',
      name: 'AddLien',
      component: AddLien
    },
    {
      path: '/lien/list',
      name: 'ShowLien',
      component: ShowLien
    },
    {
      path: '/lien/update/:id/:from',
      name: 'EditLien',
      component: AddLien
    },
    {
      path: '/customer-card/create/:id',
      name: 'AddCard',
      component: AddCard
    },
    {
      path: '/customer-card/update/:id/:from',
      name: 'EditCard',
      component: AddCard
    },

    {
      path: '/followup/update/:id/:from',
      name: 'EditFollowup',
      component: AddFollowup
    },
    {
      path: '/followup/delete/:id',
      name: 'DeleteFollowup',
      component: ShowFollowup
    },
    {
      path: '/followup/view/:id/:from',
      name: 'FollowupView',
      component: FollowupView
    },
    {
      path: '/followup/list',
      name: 'ShowFollowup',
      component: ShowFollowup
    },
    {
      path: '/followup/create/:id',
      name: 'AddFollowup',
      component: AddFollowup
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js